import './Loader.scss';

export { default } from './Loader';
